import * as React from 'react';
import { Gender, Birth, Zipcode } from '../../Profile/ProfileFields';
import { styles } from './Styles';

export default ({relationship, firstName}) => (
		<fieldset className={styles.fieldset}>
				<legend className={styles.legend}>Demographics</legend>
				<div>
						<div>What is <b>{relationship == 'myself' ? 'your' : `${firstName}'s`}</b>...</div>
						<Gender />
						<Birth />
						<Zipcode />
				</div>
		</fieldset>
);



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Pages/Demographics2.tsx